<div class="container scroll-bar" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">


  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> CII
    <mat-icon class="titleIcon">chevron_right</mat-icon> CII Inside View
  </p>
  <p class="header">
    <span class="header-name">{{ vesselName }}</span>
    <br>
    <span *ngIf="imo && subusername !== 'demo'" class="header-imo">{{ imo }}</span>
  </p>

  <div class="filter-header" style="margin-top: 25px;">
    <form [formGroup]="myreportForm" class="filter-flex-container">

      <!-- Voyage Numbers (Multi-select) -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Voyage No</mat-label>
        <mat-select formControlName="voyage_numbers" placeholder="Select Voyages" multiple>
          <mat-option *ngFor="let v of uniqueVoyages" [value]="v">{{ v }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Port Filter -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Port</mat-label>
        <mat-select formControlName="port" placeholder="Select Port">
          <mat-option value="">All Ports</mat-option>
          <mat-option *ngFor="let p of uniquePorts" [value]="p">{{ p }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Month Filter -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Month</mat-label>
        <mat-select formControlName="month" placeholder="Select Month">
          <mat-option value="">All Months</mat-option>
          <mat-option *ngFor="let m of monthOptions" [value]="m">{{ m }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Date Range (Fully Integrated Material Datepicker) -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field date-field">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="from_date" placeholder="Select Date">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="compact-field date-field">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="to_date" placeholder="Select Date">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button mat-flat-button color="warn" class="fetch-btn clear-btn" (click)="clearClick()">
        Clear
      </button>

      <button mat-flat-button color="primary" class="fetch-btn" (click)="filterClick()">
        Apply Filter
      </button>

    </form>
  </div>

  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" matSort>

      <thead class="sticky-header">
        <!-- MAIN HEADER -->
        <tr>
          <th rowspan="2">S.No</th>
          <th rowspan="2">Voyage No</th>
          <th rowspan="2">From Port</th>
          <th rowspan="2">To Port</th>

          <th colspan="2" class="text-center">COSP / EOSP</th>

          <th colspan="3" class="text-center">Fuel Consumed</th>
          <th colspan="3" class="text-center">Fuel Excluded</th>

          <th rowspan="2">Distance Travelled</th>

          <th colspan="4" class="text-center">Fuel Consumed by Equipment</th>
          <th rowspan="2" class="th-text-center">Generate Report</th>
        </tr>

        <!-- SUB HEADER -->
        <tr>
          <th>COSP (UTC)</th>
          <th>EOSP (UTC)</th>

          <th>HFO</th>
          <th>LFO</th>
          <th>MDO</th>

          <th>HFO</th>
          <th>LFO</th>
          <th>MDO</th>

          <th>Main Engine</th>
          <th>Aux Engine</th>
          <th>Boiler</th>
          <th>Power Pack</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1,2,3,4,5]">
            <td colspan="18">
              <div class="skeleton-table-row skeleton"></div>
            </td>
          </tr>
        </ng-container>

        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- <td *ngIf="subusername !== 'demo'">{{ element.imo_number }}</td> -->
            <td>{{ element.vyg_num || element.voyage_number }}</td>
            <td>{{ element.from_port || '-' }}</td>
            <td>{{ element.to_port || '-' }}</td>

            <td>{{ element.cosp_timestamp ? (element.cosp_timestamp | date:'dd/MM/yyyy HH:mm':'UTC') : '-' }}</td>
            <td>{{ element.eosp_timestamp ? (element.eosp_timestamp | date:'dd/MM/yyyy HH:mm':'UTC') : '-' }}</td>

            <!-- Fuel Consumed -->
            <td>{{ element.fuel_consumed_hfo || '-' }}</td>
            <td>{{ element.fuel_consumed_lfo || '-' }}</td>
            <td>{{ element.fuel_consumed_mdo || '-' }}</td>

            <!-- Fuel Excluded -->
            <td>{{ element.fuel_excluded_hfo || '-' }}</td>
            <td>{{ element.fuel_excluded_lfo || '-' }}</td>
            <td>{{ element.fuel_excluded_mdo || '-' }}</td>

            <td>{{ element.distance_travelled || '-' }}</td>

            <!-- Equipment Consumption -->
            <td>{{ element.me_consumption || '-' }}</td>
            <td>{{ element.ae_consumption || '-' }}</td>
            <td>{{ element.boiler_consumption || '-' }}</td>
            <td>{{ element.power_pack_consumption || '-' }}</td>

            <!-- Generate Report -->
            <td class="text-center">
              <mat-icon matTooltip="Generate CII Report" (click)="openGenerateReportPopup(element)"
                style="cursor:pointer; font-size:22px;">
                description
              </mat-icon>
            </td>
          </tr>

          <tr *ngIf="paginatedData.length === 0">
            <td colspan="18" style="text-align: center; padding: 20px; color: #718096;">
              No voyage data available for the selected filters.
            </td>
          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>




  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

  <!-- <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div> -->
  <div class="bottom-navigator">
    <div class="nav-arrow" matTooltip="Go to CII View" matTooltipPosition="above" (click)="goToNextPage()">
      ←
    </div>
  </div>


</div>

<br />